module.exports = "<exa-meters-integration [customer]=\"customers.selected$ | async\"></exa-meters-integration>\r\n"